import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const TIPPING_BASE_URL = ConfigurationService.get(ConfigurationKeys.TIPPING_BASE_URL);
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const AVAILABLE_COUNTRIES_URL = `${BASE_URL}/rest/v1.0/options/countries?full=true`;
export const TIPPING_POLLING_URL = `${TIPPING_BASE_URL}/tipper/tipping.user.php`;
export const TWITTER_INFO_URL = `${BASE_URL}/rest/v1.0/socialNetwork/{username}/twitter`;
export const DISCONNECT_FROM_TWITTER_URL = '/social/twitterHandler?act=disconnect';
export const GUEST_INFO_URL = `${BASE_URL}/guestInfo`;
